export default class Api {
  static sendUsername(email) {
    const request = new Request(
      window.CE_HUB_API_URL + `/user/forgot/username`,
      {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
          email: email
        })
      }
    );
    return fetch(request)
      .then(response => {
        return response.json();
      })
      .catch(error => {
        return error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/account/ForgotUsername/ducks/operations.js